import React from "react";
import classNames from "classnames/bind";
import styles from "./DateRangeSelector.module.scss";
import moment from "moment";
import Button from "../Button/Button";
import { CalendarFooterProps } from "./types";

const cx = classNames.bind(styles);

const CalendarFooter = ({
  currentRange,
  onApplyClick,
  onCancelClick,
  showDifference = true,
}: CalendarFooterProps) => {
  const difference =
    currentRange?.from && currentRange?.to
      ? moment(currentRange.to).diff(moment(currentRange.from), "days") + 1
      : 0;

  return (
    <div className={cx("calendarFooter")}>
      <div className={cx("footerPrompt")}>
        {showDifference &&
          (difference
            ? `${difference} ${difference > 1 ? "days" : "day"} chosen.`
            : "Choose a date range")}
      </div>

      <div>
        <Button
          as="button"
          onClick={onCancelClick}
          className={cx("cancelButton")}
        >
          Cancel
        </Button>

        <Button
          variant="primary"
          onClick={onApplyClick}
        >
          Apply
        </Button>
      </div>
    </div>
  );
};

export default CalendarFooter;
